// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 299) return "static/chunks/299.571bce5d0c3d2a3e.js";
	if (chunkId === 131) return "static/chunks/131.e85724e1642f00cf.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 730 ? "44530001" : chunkId) + "-" + {"356":"9f373af8581b2812","533":"e869c7f80ddd74db","619":"fb95f44c40e103b6","730":"bb50976fc26ac079"}[chunkId] + ".js";
};